<div class=" o-modal--big" id="AccpetTermRequest" style="width: 100%;">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" (click)="Close()"  matDialogClose></a>
          <label class="o-title o-title--white o-title--medium"> {{'ModalTermsAcceptRequestPortal.title' | translate}}</label> 
    </div>
    <mat-dialog-content style="width:95%; margin: 20px;">
            <div class="o-modal__text">
                <span class="o-text" style="white-space: pre-line;">{{'ModalTermsAcceptRequestPortal.body-terms' | translate}}</span>
            </div>
    </mat-dialog-content>
    <div class="o-modal__footer">
         <div>
             <button mat-button mat-dialog-close (click)="Close()" class="btn btn--default " style="color:black" ><u> {{'ModalTermsAcceptRequestPortal.btnCancel' | translate}} </u></button>
            <button mat-button (click)="Accept()" class="btn btn--primary" > {{'ModalTermsAcceptRequestPortal.btnAccept' | translate}} </button>
        </div> 
    </div>
</div>
 